import { render, staticRenderFns } from "./CurrentBalanceHeader.vue?vue&type=template&id=714d5121"
import script from "./CurrentBalanceHeader.vue?vue&type=script&lang=js"
export * from "./CurrentBalanceHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports